<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose" :destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="参数名称" prop="title">
        <a-input v-model="form.title" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="参数分组" prop="configGroup">
        <a-input v-model="form.configGroup" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="参数键名" prop="configName">
        <a-input v-model="form.configName" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="参数类型" prop="type">
        <a-radio-group v-model="form.type" button-style="solid">
          <a-radio-button v-for="(d, index) in configTypeOptions" :key="index" :value="d.value">
            {{ d.label }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="参数键值" prop="configValue" v-if="form.type=== 1">
        <a-input v-model="form.configValue" placeholder="请输入"  />
      </a-form-model-item>
      <a-form-model-item label="参数键值" prop="configValue" v-if="form.type=== 2">
        <editor :editorValue="'editor'" v-model="form.configValue" />
      </a-form-model-item>
      <a-form-model-item label="值" prop="configValue" v-if="form.type === 3">
        <a-input v-model="form.configValue" type="number" placeholder="请输入值" />
      </a-form-model-item>
      <a-form-model-item label="值" prop="configValue" v-if="form.type === 4">
        <a-upload :customRequest='fileUploadRequest'
                  list-type="picture-card"
                  :showUploadList="false"
                  :beforeUpload="beforeUpload"
                  @change="handleChange">
          <img v-if="form.configValue" :src="form.configValue" alt="图片" style="height:104px;max-width:300px"/>

          <div v-else>
            <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传</div>
          </div>
        </a-upload>
        <span style="color:#ff0000">图片限制小于50M,推荐规格:800*800 </span>

      </a-form-model-item>
      <a-form-model-item label="值" prop="configValue" v-if="form.type == 5">
        <a-upload :customRequest='fileUploadRequests'
                  :multiple="true"
                  :file-list="fileList"
                  @change="handleChangeWenjian">
          <a-button> <a-icon type="upload" /> Upload </a-button>
        </a-upload>
      </a-form-model-item>
<!--      <a-form-model-item label="系统内置" prop="configSystem">-->
<!--        <a-radio-group v-model="form.configSystem" button-style="solid">-->
<!--          <a-radio-button v-for="(d, index) in typeOptions" :key="index" :value="d.value">-->
<!--            {{ d.label }}-->
<!--          </a-radio-button>-->
<!--        </a-radio-group>-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="描述" prop="description">
        <a-input v-model="form.description" placeholder="请输入" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>

import { getConfig, addConfig, updateConfig } from '@/api/system/config'
import Editor from '@/components/Editor'
import UploadFileToOSS from "@/utils/upload-file-to-oss";
export default {
  name: 'CreateForm',
  props: {
    typeOptions: {
      type: Array,
      required: true
    }
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      uploadLoading: false,
      formTitle: '',
      configTypeOptions: [{"value":1,"label":"普通文本"},{"value":2,"label":"富文本"},{"value":3,"label":"数字"},{"value":4,"label":"图片"},{"value":5,"label":"文件"}],
      // 表单参数
      form: {
        id: null,
        configGroup: null,
        configName: null,
        title: null,
        description: null,
        configValue: "",
        type: 1,
        cateName: null,
        createTime: null,
        remark: null
      },
      open: false,
      fileList: [],
      rules: {
        configName: [{ required: true, message: '参数名称不能为空', trigger: 'blur' }],
        configGroup: [{ required: true, message: '参数名称不能为空', trigger: 'blur' }],
        title: [{ required: true, message: '参数键名不能为空', trigger: 'blur' }],
        configValue: [{ required: true, message: '参数键值不能为空', trigger: 'blur' }]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    handleChangeWenjian(info) {
      let fileList = [...info.fileList];

      // 1. Limit the number of uploaded files
      //    Only to show two recent uploaded files, and old ones will be replaced by the new
      fileList = fileList.slice(-1);

      // 2. read from response and show file link
      fileList = fileList.map(file => {
        if (file.response) {
          file.url = file.response.url;
        }
        return file;
      });

      this.fileList = fileList;
      // console.log('fileList')
      // console.log(fileList)
      // let index = fileList[0].originFileObj.name.lastIndexOf(".");
      // let fileType = fileList[0].originFileObj.name.substr(index + 1);
      //  let indexIndex = fileList[0].originFileObj.ossUrl.lastIndexOf(".");
      this.form.configValue = fileList[0].originFileObj.ossUrl;
      console.log(this.form.configValue);
    },
    /**
     * 上传图片
     * @param info
     */
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.uploadLoading = true
        return
      }
      if (info.file.status === 'done') {
        // let response = info.file.response;
        this.uploadLoading = false;
        this.form.configValue = info.file.originFileObj.ossUrl;
      }
    },
    fileUploadRequests(fileInfo) {
      console.log(fileInfo)
      new UploadFileToOSS([fileInfo.file], {
        finally: (res) => {
          // Log.info('multi-img-upload', res);
          const ossUrl = res[0].url;
          fileInfo.file.ossUrl = ossUrl;
          fileInfo.file.ossName = ossUrl;
          fileInfo.onSuccess();
        },
      });
    },
    fileUploadRequest(fileInfo) {
      this.uploadLoading = true

      new UploadFileToOSS([fileInfo.file], {
        finally: (res) => {
          // Log.info('multi-img-upload', res);
          const ossUrl = res[0].url;
          fileInfo.file.ossUrl = ossUrl;
          fileInfo.file.ossName = ossUrl;
          fileInfo.onSuccess();
        },
      });
    },
    beforeUpload: function (file) {
      return new Promise((resolve, reject) => {
        if(file.size>5*1024*1000){
          this.$message.warning("图片大小不能超过5M----")
          return reject(false)
        }

        var fileType = file.type;
        if (fileType.indexOf('image') < 0) {
          this.$message.warning('请上传图片');
          return reject(false);
        }
        resolve(true)
      });
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.form = {
        id: null,
        configGroup: null,
        configName: null,
        title: null,
        description: null,
        configValue: "",
        type: 1,
        cateName: null,
        createTime: null,
        remark: null
      }
    },
     /** 新增按钮操作 */
    handleAdd () {
      this.reset()
      this.open = true
      this.formTitle = '添加参数'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      const configId = row ? row.id : ids
      getConfig({ 'id': configId }).then(response => {
        this.form = response.data
        this.form.type = response.data.type
        if(response.data.type === 5) {
          this.fileList = [{
            uid: '-1',
            name: response.data.configValue,
            status: 'done',
            url: response.data.configValue,
          }];
        }
        this.open = true
        this.formTitle = '修改参数'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id != null) {
            updateConfig(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addConfig(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
